import Header from 'apps/employer_renewals/components/Header'
import PageContainer from 'apps/employer_renewals/components/layout/PageContainer'
import { ButtonLink } from 'slab'

export default function EligibilityConfirmedPage () {
  return (
    <PageContainer maxWidth='lg'>
      <Header
        heading='Eligibility confirmed'
        subheading='Thanks for confirming the eligibility of your employees. All employees marked as eligilbe will automatically be invited to enroll in plans on Nov 5. Any employees not marked as eligible will have to be invited manually from your Thatch dashboard in order to enroll.'
      />
      <div className='flex items-center justify-center'>
        <ButtonLink href='/' variant='primary' size='large'>
          Go to dashboard
        </ButtonLink>
      </div>
    </PageContainer>
  )
}
